<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  schemaJson: { type: String, default: '' },
});

const emit = defineEmits(['close', 'apply']);

const text = ref('');
const parseError = ref('');

watch(
  () => props.show,
  visible => {
    if (visible) {
      text.value = props.schemaJson;
      parseError.value = '';
    }
  }
);

const apply = () => {
  try {
    const parsed = JSON.parse(text.value);
    parseError.value = '';
    emit('apply', parsed);
  } catch (error) {
    parseError.value = error.message;
  }
};
</script>

<template>
  <div v-if="show" class="absolute inset-y-0 ltr:right-0 rtl:left-0 z-30 w-[520px] max-w-full flex flex-col bg-n-solid-1 border-l border-n-weak shadow-xl">
    <div class="flex items-center justify-between px-4 py-3 border-b border-n-weak">
      <span class="text-sm font-semibold text-n-slate-12">{{ $t('FLOWS.BUILDER.JSON.TITLE') }}</span>
      <button type="button" class="p-1 rounded text-n-slate-11 hover:bg-n-alpha-2" @click="emit('close')">
        <span class="i-lucide-x block" />
      </button>
    </div>
    <textarea
      v-model="text"
      class="flex-1 w-full !mb-0 p-3 font-mono text-xs resize-none !rounded-none !border-0"
      spellcheck="false"
    />
    <div class="px-4 py-3 border-t border-n-weak flex items-center gap-2">
      <span v-if="parseError" class="text-xs text-n-ruby-11 flex-1 truncate">{{ parseError }}</span>
      <span v-else class="text-xs text-n-slate-10 flex-1">{{ $t('FLOWS.BUILDER.JSON.HINT') }}</span>
      <button
        type="button"
        class="px-3 py-1.5 text-xs rounded-lg bg-n-brand text-white hover:brightness-110"
        @click="apply"
      >
        {{ $t('FLOWS.BUILDER.JSON.APPLY') }}
      </button>
    </div>
  </div>
</template>
